import React from 'react'
import Calendar from 'react-calendar'

export interface PaymentCalendarProps {
  setDate: (date: Date) => void
  // react-calendar's type is Value, which can be [] and null and to set it as the type we need to handle these cases
  setCalendarDate: (date: any) => void
  maxDate: Date
  minDate: Date
  date: Date
  calendarMonth: string
  calendarYear: number
}

const longDate = (date: Date): string =>
  date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })

export function PaymentCalendar({
  setDate,
  setCalendarDate,
  maxDate,
  minDate,
  date,
  calendarMonth,
  calendarYear,
}: PaymentCalendarProps) {
  return (
    <div className="refi-payment-options__section">
      <p className="refi-payment-options__section-title">Payment Options</p>
      <p className="refi-payment-options__section-text">
        {/* Dates, not "N days from today": the window is counted from the
            server's today, which is a day off near midnight UTC. */}
        Select first payment date. (Must be between {longDate(minDate)} and{' '}
        {longDate(maxDate)})
      </p>
      <div className="calendar-wrapper">
        <div className="month-year-label">
          <span className="month-label">{calendarMonth}</span>
          <span className="year-label">{calendarYear}</span>
        </div>
        <Calendar
          minDate={minDate}
          maxDate={maxDate}
          onChange={(value: any) => setDate(value)}
          value={date}
          prev2Label={null}
          next2Label={null}
          onActiveStartDateChange={({ activeStartDate }) =>
            setCalendarDate(activeStartDate)
          }
        />
      </div>
    </div>
  )
}

export default PaymentCalendar
